import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceSelectionCriteria  {
    _originalTypeClassName = "zERP.BO.InvoiceSelectionCriteria";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceSelectionCriteria.translate = translateService;
}
this.InvoiceTypes = [];
this.Id = null;
this.IsExpense = null;
this.IsRevenue = null;
this.IsAccounting = null;
this.HasAssets = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsExpense:any;
IsRevenue:any;
IsAccounting:any;
HasAssets:any;
InvoiceTypes:any;
static setInvoiceTypes = ($this, items) => {
                if (items == null) items = [];
                if ($this.InvoiceTypes == null) $this.InvoiceTypes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.InvoiceTypes.length > 0) {
                    Domain.InvoiceSelectionCriteria.removeInvoiceTypes($this, $this.InvoiceTypes[0]);
                }

                Domain.InvoiceSelectionCriteria.addManyInvoiceTypes($this, copyItems);
            }
static addManyInvoiceTypes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceSelectionCriteria.addInvoiceTypes($this, items[i]);
                }
            }
static addInvoiceTypes = ($this, item) => {
                if ($this.InvoiceTypes == null) $this.InvoiceTypes = [];
                if (item == null || $this.InvoiceTypes.indexOf(item) > -1) return;
                $this.InvoiceTypes.push(item);
}
static addRangeInvoiceTypes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceSelectionCriteria.addInvoiceTypes($this, item));
            }
static removeInvoiceTypes = ($this, item) => {
                if ($this == null || $this.InvoiceTypes == null || $this.InvoiceTypes.indexOf(item) === -1) return;
                var _index = $this.InvoiceTypes.indexOf(item);
                $this.InvoiceTypes.splice(_index, 1);
}
static clearInvoiceTypes = ($this) => { $this.InvoiceTypes = null; }

static Check($this: any, invoice: any): any{if (invoice == null) {return false;}
let no = 1;
let yes = 2;
if (CLMS.Framework.Number.Equal(() => $this.IsExpense, () => no) && invoice?.TransactionType == Domain.TransactionType.Expense) {return false;}
if (CLMS.Framework.Number.Equal(() => $this.IsExpense, () => yes) && invoice?.TransactionType != Domain.TransactionType.Expense) {return false;}
if (CLMS.Framework.Number.Equal(() => $this.IsRevenue, () => no) && invoice?.TransactionType == Domain.TransactionType.Income) {return false;}
if (CLMS.Framework.Number.Equal(() => $this.IsRevenue, () => yes) && invoice?.TransactionType != Domain.TransactionType.Income) {return false;}
if (CLMS.Framework.Number.Equal(() => $this.IsAccounting, () => no) && invoice?.TransactionType == Domain.TransactionType.Accounting) {return false;}
if (CLMS.Framework.Number.Equal(() => $this.IsAccounting, () => yes) && invoice?.TransactionType != Domain.TransactionType.Accounting) {return false;}
let hasAsset = invoice?.InvoiceDetails?.linq?.any((d) => d?.Good != null && d?.Good?.TransactionItemType == Domain.TransactionItemType.Asset);
if (CLMS.Framework.Number.Equal(() => $this.HasAssets, () => no) && hasAsset) {return false;}
if (CLMS.Framework.Number.Equal(() => $this.HasAssets, () => yes) && !(hasAsset)) {return false;}
if ($this?.InvoiceTypes?.linq?.any() && !($this?.InvoiceTypes?.linq?.contains(invoice?.InvoiceHeader?.InvoiceType))) {return false;}
return true;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}